/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import { observable, action, ObservableMap, flow } from 'mobx';
import {
    generateDetail,
    generateList,
    generateCreate,
    generateUpdate,
    generateListMore,
    generateDelete,
} from './actionCreator';
import _ from '../translations';
import get from 'lodash/get';
import ErrorsStore from './errorsStore';
import fetch from '../fetch';
class LandingStore {
    constructor() {
        this.baseUrl = '/api/core/landing';
    }

    @observable collection = new ObservableMap();
    @observable details = new ObservableMap();
    @observable landing = {};
    @action
    reset = () => {
        this.collection.clear();
        this.landing = {};
        this.details.clear();
    };

    @action.bound
    detail = flow(function*({ _id = false } = {}) {
        return yield generateDetail({
            _id,
            url: `${this.baseUrl}`,
            store: this,
            customError: _('There was a problem fetching the news'),
        })();
    });

    @action.bound
    list = flow(function*({ hash, params = {} } = {}) {
        params.notExists = 'termsAndConditions';

        return yield generateList({
            hash,
            params,
            url: this.baseUrl,
            store: this,
            customError: _('There was a problem listing news'),
        })();
    });

    @action.bound
    getLanding = flow(function*() {
        try {
            const list = yield fetch.get({
                url: this.baseUrl,
                params: {
                    itemsPerPage: 1,
                },
            });
            const landing = get(list, 'items[0]', false);
            if (list && list.error && !list.items) {
                ErrorsStore.addError(list, _('Could not get Landing page'));
            } else {
                this.landing = landing;
            }
        } catch (e) {
            ErrorsStore.addError(e, _('Could not get Sitemap'));
            console.warn(e);
        }
    });

    @action.bound
    listMore = flow(function*({ hash, params = {} } = {}) {
        params.notExists = 'termsAndConditions';
        return yield generateListMore({
            hash,
            params,
            url: this.baseUrl,
            store: this,
            customError: _('There was a problem listing news'),
        })();
    });

    @action.bound
    create = flow(function*({ item = {} } = {}) {
        return yield generateCreate({
            item,
            url: this.baseUrl,
            store: this,
            customError: _('There was a problem creating the news'),
        })();
    });

    @action.bound
    update = flow(function*({ items, item = {} } = {}) {
        return yield generateUpdate({
            items,
            item,
            url: `${this.baseUrl}/multiple`,
            store: this,
            customError: _('There was a problem updating the news'),
        })();
    });

    @action.bound
    delete = flow(function*({ items, _id = false, type = 'logical' } = {}) {
        return yield generateDelete({
            items,
            _id,
            type,
            url: `${this.baseUrl}/multiple`,
            store: this,
            customError: _('There was a problem deleting the news'),
        })();
    });
}

export default new LandingStore();
